import React from 'react';

const ToggleButton = ({ selected, setSelected }) => {
    const handleToggle = () => {
        const newSelected = selected === "login" ? "register" : "login";
        setSelected(newSelected);
    };

    return (
        <div className="toggle-container mx-auto" onClick={handleToggle}>
            <div className="toggle-switch light-toggle">
                <div
                    className="slider"
                    style={{
                        left: selected === "login" ? "0" : "50%",
                        background: "linear-gradient(to right, #a855f7, #3b82f6)",
                        boxShadow: "0 4px 12px rgba(168, 85, 247, 0.3)"
                    }}
                />
                <span className={`toggle-option ${selected === "login" ? "active" : ""}`}>
                    Login
                </span>
                <span className={`toggle-option ${selected === "register" ? "active" : ""}`}>
                    Register
                </span>
            </div>
        </div>
    );
};

export default ToggleButton;